import { Injectable } from "@angular/core";
import { Shared } from "@rubii/frontend-common";

@Injectable()
export class RoleService {
    defaultUserRoles = [
        { id: Shared.dicts.UserRoles.ADMIN, name: 'Admin', icon: 'admin' },
        { id: Shared.dicts.UserRoles.AM, name: 'Standard', icon: 'person' },
        { id: Shared.dicts.UserRoles.EXTERNAL, name: 'External', icon: 'external-user' },
    ];

    getUserRoleByRoleId(id: number) {
        if ([Shared.dicts.UserRoles.AM, Shared.dicts.UserRoles.TRADER].indexOf(id) > -1) {
            id = Shared.dicts.UserRoles.AM;
        }
        return this.defaultUserRoles.find(x => x.id === id);
    }
}